import { FC, useCallback, useState } from "react";
import { HeadButton } from "../../../../components/HeadButtons/styles";
import { DocumentIcon } from "../../../../components/MuiIcons";
import { TOnboardingConfig } from "../../../app/models";
import { useVerificationContext } from "../../context/useVerification";
import { TUserFullInfo, TVerificationRequest } from "../../models";
import { ICompanyVerificationStatusesConfig } from "../../network";
import { TResult } from "../../hooks/useDocumentListWithData";
import { generatePdf } from "./buildPDF";

export const ApplicantSummaryButton: FC<{
  documents: TResult;
  statusesConfig: ICompanyVerificationStatusesConfig;
  userInfo: TUserFullInfo;
  comments: any;
  data: TVerificationRequest;
  id: string | undefined;
  onboardingConfig: TOnboardingConfig | null;
}> = ({
  documents,
  userInfo,
  comments,
  data,
  id,
  statusesConfig,
  onboardingConfig,
}) => {
  const { countriesRegex } = useVerificationContext();
  const [isLoading, setIsLoading] = useState(false);

  const handleGeneratePdf = useCallback(async () => {
    if (!id) return;

    setIsLoading(true);
    try {
      await generatePdf({
        documents,
        userInfo,
        comments,
        data,
        id,
        statusesConfig,
        countriesRegex,
        onboardingConfig,
      });
    } finally {
      setIsLoading(false);
    }
  }, [
    data,
    documents,
    id,
    comments,
    countriesRegex,
    userInfo,
    statusesConfig,
    onboardingConfig,
  ]);

  return (
    <>
      <HeadButton
        variant='text'
        onClick={handleGeneratePdf}
        startIcon={<DocumentIcon />}
        disabled={isLoading}
        sx={{
          "& .MuiButton-startIcon": {
            marginRight: "4px",
            position: "relative",
            top: "2px",
          },
        }}
      >
        Applicant Business Profile
      </HeadButton>
    </>
  );
};
